import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetCustomersQuery } from '@/api/v2/customer';
import { CustomerDetailsContent } from './components/details/CustomerDetailsContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const CustomerDetails: PageWithLayout = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');

    const { data } = useGetCustomersQuery({
        search: id as string,
    });

    const customer = data?.content?.[0];

    useEffect(() => {
        if (customer) {
            document.title = `Kunde | ${customer.lastname} | Starjack Admin`;
        }
    }, [customer]);

    if (!customer) return null;

    return (
        <>
            <CustomerDetailsContent customer={customer} />
        </>
    );
};

CustomerDetails.isProtected = true;
CustomerDetails.permissions = [Permission.CUSTOMER_DETAIL_NAV];

CustomerDetails.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default CustomerDetails;
